import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  compareToHash,
  hashToSelectedValues,
  updateHash,
} from "../../utilities/hash";
import { useSelector } from "react-redux";
import localization from "../../data/config";
import { match } from "../../utilities/arrays";
import * as HASH from "../../constants/config/hash";
import "./style.css";

const { showSelectedLabel } = localization;

const ShowSelected = () => {
  let selectedRows = hashToSelectedValues();
  const selected = useSelector((state) => state.parts.selected),
    data = useSelector((state) => state.parts.data),
    [selecting, setSelecting] = useState(false);
  const isEnabled = () => selected.length >= 0,
    [disabled, setDisabled] = useState(false),
    prevSelected = useRef(selected);


    //useEffect to add or remove parts id to the url when show selected is toggled
  useEffect(() => {
    let newDisabled = !isEnabled();
    if (newDisabled !== disabled) setDisabled(newDisabled);
    if (!match(prevSelected, selected)) {
      if (selected.length > 0) {
        createHash(selecting);
      } else {
        createHash(false);
      }
    }
  }, [selected]);

  /**
   * @name setSelection
   * @function
   * @description Callback for the button click
   */
  const setSelection = () => {
    let newSelect = !selecting;
    createHash(newSelect);
    setSelecting(newSelect);
  };

  /**
   * @name createHash
   * @function
   * @description Updates the hash in the URL when comparing
   * @param {boolean} currentSelect determines if the hash should have a value
   */
  function createHash(currentSelect) {
    let hash = null;
    if (currentSelect) hash = compareToHash(selected);
    updateHash(HASH.COMPARE, hash);
  }

        /**
    * Handles the key press event, triggering an action if Enter key is pressed.
    *
    * @param {KeyboardEvent} event - The key press event.
    */
         const handleKeyDown = (event) => {
          if (event.key === 'Enter') {
            setSelection();
          }
        };

  return (
    <div className="showSelected">
      <p>{showSelectedLabel}</p>
      <label className="switch" tabIndex={-1}>
        <input
          type="checkbox"
          role="checkbox"
          onClick={setSelection}
          onKeyPress={handleKeyDown}
          tabIndex={0} 
          aria-label={localization.showSelectedLabel}
        />
        <span className="slider round" tabIndex={-1} ></span>
      </label>
    </div>
  );
};

ShowSelected.defaultProps = {
  selected: [],
};

ShowSelected.propTypes = {
  selected: PropTypes.array,
};

export default ShowSelected;
